/* eslint-disable react/prop-types */
import React from "react";

import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/modal";
import { Button } from "@nextui-org/button";

const ConfirmSubmitTicketModal = ({ isOpen, onOpenChange, onConfirm }) => {
  return (
    <>
      <Modal
        placement="center"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        closeButton={
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: "16px",
              top: "14px",
              background: "transparent",
            }}
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="bg-dark-gray text-white">
                ยืนยันการสร้างคำของบประมาณ
              </ModalHeader>
              <ModalBody className="flex flex-col md:flex-row md:gap-x-3 gap-y-3 justify-center py-10 px-3">
                <div className="flex flex-col gap-y-5 items-center">
                  <p>คุณจะไม่สามารถแก้ไขคำขอได้ถ้าได้ยื่นคำขอไปแล้ว</p>
                  <div className="flex flex-row">
                    <Button
                      className="bg-blue-500 text-white w-full mx-5 px-12"
                      onPress={onConfirm}
                    >
                      ยืนยัน
                    </Button>
                    <Button
                      className="bg-light-gray-300 text-white w-full mx-5 px-12"
                      variant="light"
                      onPress={onClose}
                    >
                      ยกเลิก
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ConfirmSubmitTicketModal;
